import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sum',
})
export class SumPipe implements PipeTransform {
    transform(value: any[], column: string): number {
        if (!value || !Array.isArray(value) || !column) {
            return 0;
        }
        return value.reduce((acc, item) => acc + (item[column] || 0), 0);
    }
}
